import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./tailwind.output.css";
import "react-datepicker/dist/react-datepicker.css";
// import reportWebVitals from "../reportWebVitals";

import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
